<template>
  <div class="container">
    <div>
        <el-button type="primary" @click="add">新增关键词</el-button>
    </div>
    <div class="mt18">
        <customTable :row-class-name="keywordTableRow" border :column="column" :tableData="list" :total="total" :currentPage="searchForm.pageNum" :currentPageSize="searchForm.pageSize" @pageChange="pageChange">
            <template slot="action" slot-scope="{ row }">
                <el-button type="text" @click="handleEdit(row.id)">修改</el-button>
                <el-button type="text" class="colorF54A" @click="handleDel(row.id)">删除</el-button>
            </template>
            <template slot="files" slot-scope="{ row }">
                <el-image v-for="(item,index) in row.files" :key="index" class="mr8 "
                        style="width: 48px; height: 48px;border-radius: 2px ;" :src="item">
                    </el-image>
            </template>
        </customTable>
    </div>
    <customDialog :title="dialogTitle" v-if="dialogShow" :visible="dialogShow" width="555px" @close="closeDialog" @cancel="closeDialog" top="5vh" @save="dialogSave">
        <el-form slot="content" :model="form" :rules="rules" ref="form" label-width="80px" class="demo-ruleForm">
            <el-form-item label="名称" prop="name">
                <el-input v-model.trim="form.name" placeholder="请输入" maxlength="50" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="关键词" :prop="'keywords.' + index" v-for="(item, index) in form.keywords" :key="index"  
            :rules="{ required: true, message: '关键词不能为空', trigger: 'blur'}" >
              <div class="flex align-i-c">
                <el-input v-model.trim="form.keywords[index]" placeholder="请输入" maxlength="50" show-word-limit></el-input>
                <i v-if="form.keywords.length>1" @click="delKeyword(index)" class="el-icon-delete ml8"></i>
              </div>
            </el-form-item>
            <div class="pl80 mb22">
                <el-button type="text" @click="addKeyword">添加关键词</el-button>
            </div>
            <el-form-item label="文案" prop="content">
                <el-input v-model.trim="form.content" type="textarea" maxlength="500" show-word-limit :autosize="{minRows: 3, maxRows: 10}"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="files">
               <div class="flex flex-w">
                <div class="position-r w80" v-for="(im,imgIndex) in form.files" :key="im">
                    <el-image @click="handlePictureCardPreview($event,imgIndex)" class="mr8 "
                        style="width: 80px; height: 80px;border-radius: 2px ;" :src="im">
                    </el-image>
                    <div class="del" @click="handleRemove(imgIndex)"><i class="el-icon-close size12"></i></div>
                </div>
                <Upload v-if="form.files.length <5" v-loading="uploading" ref="uploadImage" @on-success="handleImgSuccess" accept=".png,.jpg,.jpeg" class="mr8">
                    <el-button class="upload" type="primary" size="small" @click="localUpload">
                      <i class="el-icon-plus"></i>
                    </el-button>
                </Upload>
               </div>
               <div class="color6671">支持jpg、png，最多支持上次5张</div>
            </el-form-item>
        </el-form>
    </customDialog> 
  </div>
</template>

<script>
import customTable from '@/components/customTable/customTable'
import CustomDialog from '@/components/customDialog/CustomDialog'
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import {keywordReplyDTO} from '@/DTO/index'
import {msgboxWarning,isNull, isNullObj, deepClone} from '@/utils/validateBase'
import Upload from '@/components/Upload/Upload'
export default {
    components:{customTable,CustomDialog,Upload},
    data(){
        return{
            column:[
                { type: "index", label: "",width:40 },
                { label: "名称", prop: "name",align:'left' },
                { label: "关键词", prop: "keywords",formatter:(row)=>{ return row.keywords.join('/') },align:'left' },
                { label: "文案", prop: "content",align:'left' },
                { label: "图片", slotName: "files",align:'left' },
                { label: "操作", slotName: "action",width:140 ,align:'left'},
            ],
            list:[],
            dialogShow:false,
            form:{
                name:'',
                keywords:[''],
                content:'',
                files:[]
            },
            rules:{
                name: [
                    { required: true, message: '请输入关键词名称', trigger: 'blur' },
                ],
                content:[
                    { required: true, message: '请输入文案', trigger: 'blur' },
                ],
            },
            uploadUrl: this.$filePath + '/xl/upload/temp/file/upload', // 图片上传接口地址
            searchForm:{
                pageNum:1,
                pageSize:10
            },
            total:0,
            uploading:false,
            dialogTitle:''
        }
    },
    created(){
        this.getPage()
    },
    methods:{
        keywordTableRow({}){
            return 'keywordTableRow'
        },
        closeDialog(){
            this.dialogShow=false;
            this.form={
                name:'',
                keywords:[''],
                content:'',
                files:[]
            }
        },
        //添加关键词
        addKeyword(){
            this.form.keywords.push('')
        },
        //删除关键字
        delKeyword(index){
            this.form.keywords.splice(index,1)
        },
        //新增
        add(){
            this.dialogTitle = '新增关键词'
            this.dialogShow=true;
        },
        //弹框确定
         dialogSave(){
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if(isNull(this.form.id)){
                        //新增
                        let {code   } = await keywordReplyDTO.addKeyword(this.form)
                        if(code==200){
                            this.closeDialog()
                            this.$message.success('新增成功')
                            this.handleRefresh()
                        }
                    }else{
                        //修改
                        let {code} = await keywordReplyDTO.editKeyword(this.form)
                        if(code==200){
                            this.closeDialog()
                            this.$message.success('修改成功')
                            this.getPage()
                        }
                    }
                }
            });
            
        },

        //获取分页数据
        async getPage(){
            let {code,rows,total}=await keywordReplyDTO.getPage(this.searchForm)
            if(code==200){
                this.list = rows || [];
                this.total=total
            }
        },

        //页码改变
        pageChange(obj) {
            let { current, size } = obj
            this.searchForm.pageNum = current
            this.searchForm.pageSize = size
            this.getPage()
        },
        //删除
        handleDel(id){
            msgboxWarning(this, {
                message: "删除后不可恢复，确定删除？",
                confirmFn: async () => {
                  {
                    let { code, data } = await keywordReplyDTO.delKeyword({ id })
                    if (code == 200) {
                        this.$message.success('删除成功')
                        this.handleRefresh()
                    }
                  }
                },
                cancelFn: () => {
                },
            });
        },
        //获取详情
        getDetail(id){
            return new Promise(async (resolve, reject) => {
                let {code,data} = await keywordReplyDTO.getDetail({id})
                if(code==200){
                    resolve(data)
                }
            })
        },
        //修改
        async handleEdit(id){
            this.dialogTitle = '修改关键词'
            let data = await this.getDetail(id)
            if(!isNull(data) && !isNullObj(data)){
                this.form = deepClone(data)
                this.dialogShow = true;
            }
        },
        //从第一页刷新
        handleRefresh(){
            this.searchForm.pageNum=1
            this.getPage()
        },
        //图片删除
        handleRemove(fileIndex){
            this.form.files.splice(fileIndex,1)
        },

        //图片上传成功
        handleImgSuccess(data){
            this.uploading = true
            let arr = []
            arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
            uploadTemporaryFile(arr).then(uploadRes => {
              this.uploading = false
              if (uploadRes.errorCode == '0000') {
                this.form.files.push(uploadRes.data[0].fullPathUrl)
              } else {
                this.$message.error('上传失败')
              }
            }).catch(err => {
              this.uploading = false;
              this.$message.error('上传失败')
            })
        },
        localUpload(){}
    }
}
</script>

<style lang="less" scoped>
/deep/.keywordTableRow{
    height: 68px;
    .cell{
        white-space: pre-wrap;   
    }
}
.demo-ruleForm{
    /deep/.el-input__inner{
        padding-right: 50px;
    }
    /deep/.el-input__count{
        .el-input__count-inner{
            background: transparent;
        }
        background: transparent;
    }
    .upload {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        border-radius: 2px;
        border: 1px dashed #D3D3D5;
        background-color: #FFF;
        color: #9AA0A8;
    }
    .del{
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: -2px;
        right: 0px;
        height: 14px;
        width: 14px;
        border-radius: 50%;
        color: #9AA0A8;
        background: #F0F1F3;
    }
}

</style>